// import React, { useEffect, useState } from 'react'
// import AdminHeader from '../AdminHeader'
// import './AdminOrderDS.css'
// import { Button, Col, Container, Form, Modal, Row, Table } from 'react-bootstrap'
// import axios from 'axios'
// import { toast } from 'react-toastify'
// import { Autocomplete, TextField } from '@mui/material'
// import { DailyStockAdd, DailyStockDelete, DailyStockFindAll, DailyStockUpdate, EmployeeFindAll, ProductFindAll, ProductFindAllOrderAllotment } from '../../API/Api'

// const DailyStock = () => {

//   const [isEditing, setisEditing] = useState(false);
//   const [show, setShow] = useState(false);
//   const [data, setData] = useState([]);
//   const [date, setDate] = useState();
//   const [id, setId] = useState();
//   const [quantity, setQuantity] = useState();
//   // const [stockId, setStockId] = useState();
//   const [product_master, setProduct_master] = useState([]);
//   const [employee_master, setEmployee_master] = useState([]);
//   const [productId, setProductId] = useState();
//   const [employeeId, setEmployeeId] = useState();
//   const [editData, setEditData] = useState({});
  

//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);
//   const [showEdit, setShowEdit] = useState(false);

//   // =========== delete modal =========
//  const [show1, setShow1] = useState(false);
//  const handleClose1 = () => setShow1(false);

//  const [itemToDelete, setItemToDelete] = useState(null);

//  const handleShow1 = (item) => {
//    setItemToDelete(item);
//    setShow1(true);
//  };  


// //  =========== Edit ======
//   const handleEditClose = () => {
//     setShowEdit(false);
//     // setStockId('');
//     setQuantity('');
//     setProductId('');
//     setDate('');
//     setEmployeeId('');
//     setId('');
//   };

//   const setEditDataFun = (item) => {
//     console.log("Setting isEditing to true");
//     setProductId(item.product_id);
//     setEmployeeId(item.employee_id);
//     // setStockId(item.stock_id);
//     setId(item.id);
//     setQuantity(item.quantity);
//     setDate(item.date);
//     setisEditing(true);
//   }

//   const updateDailyStock = () => {

//     if ( !productId  || !quantity) {
//       alert("Please fill in all fields");
//       return;
//   }

//     const formData = {
//       product_id :productId,
//       quantity :quantity,
//       employee_id : employeeId,
//       date : date
//     };
//     axios
//       .put(`${DailyStockUpdate}${id}`, formData)
//       .then((res) => {
//         if (res.data === "UPDATE") {
          
//           toast.success("Data Updated Successfully!", {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//           Getdata();
//           handleEditClose();
//         }
//         else if(res.data === "ALREADYEXIST")
//         toast.info("Data Already Exists ..!", {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//       })
//       .catch((err) => {
//         // Add debugging information to identify the issue
//         console.error("Error while updating Employee:", err);
//         if (err.response) {
//           console.error("Response data:", err.response.data);
//         }
  
//         toast.error("Failed to update data, please try again", {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//       });
//   };


// const savedata = (e) => {
//     e.preventDefault();
  
//     if ( !productId  || !employeeId || !date || !quantity) {
//       alert("Please fill in all fields");
//       return;
//   }
  
//     const obj ={
//       employee_id : employeeId,
//       product_id :productId,
//       quantity :quantity,
//       date :date
//     }
//     console.log("FormData",obj)
  
//     axios
//       .post(DailyStockAdd, obj)
//       .then((res) => {
        
//         if (res.data === "SAVED") {
//           console.log("res.data",res.data)
//           toast.success("Data Saved Successfully!", {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//           // Reset form fields and reload the data
//           Getdata();
//           setProductId('');
//           setEmployeeId('');
//           // setStockId('');
//           setDate('');
//           setId('');
//           setQuantity('');
//           setShow(false);
//           // window.location.reload(); // Note: Reloading the entire page may not be the best practice, consider updating the data from the API.
//         }
//         else if(res.data === "ALREADYEXIST")
//         toast.info("Data Already Exists ..!", {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//       })
//       .catch((err) => {
//         toast.error("Failed to upload, please try again", {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//         console.error(err);
//       });
//   };

//      //Getdata Logic
//      const Getdata = (e) => {

//       if (!date) {
//         // date is not set, handle accordingly
//         return;
//       }
//       console.log("api call .",`${DailyStockFindAll}/${date}/${employeeId}`)
//       axios  
//         .get(`${DailyStockFindAll}/${date}/${employeeId}`)
//         .then((res) => {
//           console.log("findallllllllll",res.data)
//           if (res.data !== null) {
//             setData(res.data);
//           }
//           setisEditing(false);
//         })
//         .catch((err) => {
//           // alert("Failed to upload, try again");
//           toast.error("Failed to upload, try again", {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//           console.log(err);
//         });
//     };
  
//   // useEffect(() => {
//   //   Getdata();
//   // }, [date,employeeId])
  
  
//     //delete data
//     const onDelete = (item) => {
//       console.log("Deleting item:", item);
//       axios
//         .delete(`${DailyStockDelete}${item.id}`)
//         .then((res) => {
//           console.log("Delete response:", res.data);
//           if (res.data === "DELETE") {
//             toast.success("Data Deleted Successfully!", {
//               position: "top-right",
//               autoClose: 3000,
//               hideProgressBar: false,
//               closeOnClick: true,
//               pauseOnHover: true,
//               draggable: true,
//             });
    
//             // Update the data state to remove the deleted item
//             setData((currentData) => {
//               return currentData.filter((dataItem) => dataItem.id !== item.id);
//             });
//           }
//           handleClose1(false);
//           // No need to call Getdata() if you're updating the state directly
//         })
//         .catch((err) => {
//           console.log("Error deleting item:", err);
//           toast.error("Failed to delete, please try again", {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//         });
//     };
    
//      //EmployeeData Logic
//  const Employeedata = (e) => {
//   axios  
//     .get(EmployeeFindAll)
//     .then((res) => {
//       if (res.data !== null) {
//         setEmployee_master(res.data);
//       }
//       setisEditing(false);
//     })
//     .catch((err) => {
//       // alert("Failed to upload, try again");
//       toast.error("Failed to upload, try again", {
//         position: "top-right",
//         autoClose: 3000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//       });
//       console.log(err);
//     });
// };


//    //ProductData Logic
//  const Productdata = (e) => {
//   axios  
//     .get(ProductFindAllOrderAllotment)
//     .then((res) => {
//       if (res.data !== null) {
//         setProduct_master(res.data);
//       }
//       setisEditing(false);
//     })
//     .catch((err) => {
//       // alert("Failed to upload, try again");
//       toast.error("Failed to upload, try again", {
//         position: "top-right",
//         autoClose: 3000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//       });
//       console.log(err);
//     });
// };


// useEffect(() => {
//   if (isEditing === false) {
//     Getdata();
//     Productdata();
//     Employeedata();

//   }
// }, [isEditing]);

//  //HEADING FONT ===================

//  const headingStyle = {
//   fontSize: '27px',
//   fontWeight: 'bold',
//   textAlign: 'center',
// };

// const subheadingStyle = {
//   color: 'rgb(255, 93, 0)', // Assuming this is the color for "text-violet-800"
//   fontWeight: 300, // Assuming this is the font weight for "font-[300]"
//   textShadow:"3px 1px 5px rgb(180, 180, 180)",
// };
  
//   return (
//     <Container>
//         <Row> <AdminHeader /> </Row>

//         <Row  className='BgImg px-md-5'>

//    {/* ====================== table =============== */}
//      <Row className='m-0 p-0  px-md-5  py-1 mb-5  w-100' style={{display:"flex"}}>

//    <Row className='pt-3'>
//    <div className="heading text-black pt-3 pt-2 pt-md-2 mt-2 mt-md-1 mb-3" style={headingStyle}>
//            <span style={subheadingStyle}>Daily</span> Stock
//            </div>
//    </Row>
//    <Row style={{display:"flex",justifyContent:"space-evenly"}}>
//    <Col sm={12} md={3} className='mt-3'>
//   {isEditing ? (
//     <TextField
//       size="small"
//       type="date"
//       style={{ width: '100%' }}
//       value={date || ''}
//       readOnly
//     />
//   ) : (
//     <TextField
//       size="small"
//       style={{ width: '100%' }}
//       type="date"
//       value={date || ''}
//       onChange={(e) => setDate(e.target.value)}
//     />
//   )}
// </Col>
//     <Col sm={12} md={3} className='mt-3'>
//   {isEditing ? (
//     <TextField
//       size="small"
//       style={{ width: '100%' }}
//       label="Select Employee"
//       value={employee_master.find((item) => item.employee_id === employeeId)?.name || ''}
//       readOnly
//     />
//   ) : (
//     <Autocomplete
//       disablePortal
//       size="small"
//       style={{ width: '100%' }}
//       id="combo-box-demo"
//       options={employee_master}
//       getOptionLabel={(option) => option.name}
//       value={employee_master.find((item) => item.employee_id === employeeId) || null}
//       onChange={(e, newValue) => setEmployeeId(newValue ? newValue.employee_id : '')}
//       renderInput={(params) => <TextField {...params} label="Select Employee" />}
//     />
//   )}
// </Col>

//    <Col sm={12} md={3} className='mt-3'>
//        <Autocomplete
//           disablePortal
//           style={{ width: '100%' }}
//           id="combo-box-demo"
//           options={product_master}
//           size="small"
//           getOptionLabel={(option) => option.product_name} 
//           value={product_master.find((item) => item.product_id === productId) || null}
//           onChange={(e, newValue) => setProductId(newValue ? newValue.product_id : '')}
//           renderInput={(params) => <TextField {...params} label="Select Product" />}
//         />
//       </Col>

//       <Col sm={12} md={3} className='mt-3'>
//           <TextField
//           size="small"
//           id="outlined-basic"
//           style={{ width: '100%' }}
//           label="Enter Quantity"
//           placeholder='Enter Quantity'
//           type="number"
//           value={quantity}
//           onChange={(e) => setQuantity(e.target.value)}
//         />
//       </Col>
//    </Row>

//    <Row  className='mt-4 mb-3'>
//    <Col style={{ display: "flex", justifyContent: "center" }}>
//       {isEditing === false ? (
//         <Button
//           style={{
//             border: "0px",
//             backgroundImage:
//               "linear-gradient( 180.5deg, rgba(214, 234, 248)  12.3%, rgb(64, 224, 208) 92% )",
//             borderRadius: "15px",
//           }}
//           className="py-2 px-3 mx-2 shadow text-dark"
//           type="submit"
//           onClick={savedata}
//         >
//           Save
//         </Button>
//       ) : (
//         <div>
//         <Button
//           style={{
//             border: "1px solid darkslategray",
//             backgroundColor: "darkslategray",
//             borderRadius: "15px",
//           }}
//           className="py-2 px-3 mx-2 shadow text-light"  
//           onClick={updateDailyStock}
//         >
//           Update
//         </Button>
//         </div>
        
//       )}
//     </Col>
//       </Row>

//    <div style={{ overflowY: 'auto'}}>
//   <div style={{ overflowX: 'auto' }}>
//      <Table striped bordered hover size="sm" className='shadow mb-5 mt-2' style={{textAlign:"center"}}>
//          <thead >
//              <tr > 
//                  <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Sr.No</th>
//                  <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Date</th>
//                  <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Employee</th>
//                  <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Product</th>
//                  <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Quantity</th>
//                  <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Edit</th>
//                  <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Delete</th>
//              </tr>
//          </thead>
//          <tbody>
//            {data.map((item,index)=>{
//              return(               
//              <tr className='border' >
//                  <td style={{ textAlign:"center"}}>{index+1}</td>
//                  <td style={{ textAlign:"center"}}>{item.date}</td>
//                  <td style={{ textAlign:"center"}}>{item.name}</td>
//                  <td style={{ textAlign:"center"}}>{item.product_name}</td>
//                  <td style={{ textAlign:"center"}}>{item.quantity}</td>
//                  <td style={{textAlign:"center"}}>
//                 <button className=' m-1' style={{color:"orange",border:"0px", backgroundColor:"transparent"}}
//                   onClick={() => setEditDataFun(item)}
//                 ><i class="fa-solid fa-pen-to-square"></i></button></td>

//                 <td style={{textAlign:"center"}}>
//                 <button className=' m-1' style={{color:"red",border:"0px", backgroundColor:"transparent"}}
                
//                 onClick={() => handleShow1(item)}
//                  ><i className="fa-solid fa-trash"></i></button></td>
//              </tr>
//               )
//              })} 
//          </tbody>
//      </Table>
//      </div>
//      </div>
//    </Row>

//  {/* ========================== Modal ============= */}
//  {/* <Modal className='shadow rounded' show={show} onHide={handleClose}>
//     <Modal.Header className='m-0 p-0 ps-3 text-center' style={{backgroundImage:" linear-gradient( 180.5deg, rgba(214, 234, 248)  12.3%, rgb(64, 224, 208) 92% )",color:"black"}} >
//       <Modal.Title >
//   <p style={{fontSize:"15px"}} className='text-center mt-2'><b>Daily Stock</b></p>
//   </Modal.Title>
// </Modal.Header>

//   <Modal.Body>
//   <Form encType="multipart/form-data">
//   <Row className='m-0'>

//     <Col sm={12} md={12} className='mt-3'>
//       <Form.Label><h6 ><b>Date:</b></h6></Form.Label>
//       <Form.Control
//           type="date"
//           aria-label="Default select example"
//           onChange={handleDateChange}
//           value={date}
//           required
//         />
//       </Col>

//     <Col sm={12} md={12} className='mt-3'>
//       <Form.Label><h6 ><b>Product :</b></h6></Form.Label>
//        <Autocomplete
//     disablePortal
//     size="small"
//     id="combo-box-demo"
//     options={product_master}
//     getOptionLabel={(option) => option.product_name} 
//     value={product_master.find((item) => item.product_id === productId) || null}
//     onChange={(e, newValue) => setProductId(newValue ? newValue.product_id : '')}
//     renderInput={(params) => <TextField {...params} label="Select Product" />}
//   />
//       </Col>

//       <Col sm={12} md={12} className='mt-3'>
//       <Col >
//     <TextField
//     size="small"
//             type="date"
//             value={quantity} 
//             onChange={(e) => setQuantity(e.target.value)}
//           />
//     </Col>
//       </Col>

//       <Col sm={12} md={12} className='mt-3 mb-3'>
//         <Form.Label><h6 ><b>Employee :</b></h6></Form.Label>
//           <Autocomplete
//           disablePortal
//           id="combo-box-demo"
//           size="small"
//           options={employee_master}
//           getOptionLabel={(option) => option.name} 
//           value={employee_master.find((item) => item.id === employeeId) || null}
//           onChange={(e, newValue) => setEmployeeId(newValue ? newValue.id : '')}
//           renderInput={(params) => <TextField {...params} label="Select Employee" />}
//         />
//       </Col>

//     </Row>
//     </Form>
//   </Modal.Body>

// <Modal.Footer className='m-0 p-0' style={{backgroundImage:" linear-gradient( 180.5deg, rgba(214, 234, 248)  12.3%, rgb(64, 224, 208) 92% )"}}>
//   <Button style={{color:"black",backgroundColor:"white",border:"2px solid darkslategray",borderRadius:"15px"}} onClick={handleClose}>
//     Cancel
//   </Button>

//   {
//     isEditing===false ? 
//       <Button style={{border:"1px solid darkslategray",backgroundColor:"darkslategray" ,borderRadius:"15px"}} className='py-2 px-3 mx-2  shadow text-light' type='submit'
//        onClick={savedata}
//       >
//         Save 
//       </Button>
//       :
//       <Button style={{border:"1px solid darkslategray",backgroundColor:"darkslategray" ,borderRadius:"15px"}} className='py-2 px-3 mx-2  shadow text-light' type='submit' onClick={handleClose}>
//         Update
//       </Button>
//       }
// </Modal.Footer>
// </Modal> */}

//  {/* ============= Delete Modal ========= */}

//   <Modal show={show1} onHide={handleClose1}>
//       <Modal.Header style={{backgroundImage:" linear-gradient( 180.5deg, rgba(214, 234, 248)  12.3%, rgb(64, 224, 208) 92% )",color:"black"}} >
//         <Modal.Title><i className="fa-solid fa-trash" style={{ color: "rgb(254, 105, 129)" }}></i>  Delete Confirmation</Modal.Title>
//       </Modal.Header>
//       <Modal.Body >Are you sure you want to delete this item?</Modal.Body>
//         <p className='text-end'>
//         <Button className='mx-2' style={{color:"black",backgroundColor:"white",border:"2px solid darkslategray",borderRadius:"15px"}}  onClick={handleClose1}>
//           Cancel
//         </Button>
//         <Button  style={{border:"1px solid darkslategray",backgroundColor:"darkslategray" ,borderRadius:"15px"}} className='py-2 px-3 mx-2  shadow text-light' onClick={() => onDelete(itemToDelete)}>
//           Delete
//         </Button></p>
//     </Modal>

// </Row>

//     </Container>
//   )
// }

// export default DailyStock





import React, { useEffect, useState } from 'react'
import AdminHeader from '../AdminHeader'
import './AdminOrderDS.css'
import { Button, Col, Container, Form, Modal, Row, Table } from 'react-bootstrap'
import axios from 'axios'
import { toast } from 'react-toastify'
import { Autocomplete, TextField } from '@mui/material'
import { DailyStockAdd, DailyStockDelete, DailyStockFindAll, DailyStockUpdate, EmployeeFindAll, ProductFindAll, ProductFindAllOrderAllotment } from '../../API/Api'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';

const DailyStock = () => {

  const [isEditing, setisEditing] = useState(false);
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
 const [date, setDate] = useState(null);
  const [id, setId] = useState();
  const [quantity, setQuantity] = useState();
  // const [stockId, setStockId] = useState();
  const [product_master, setProduct_master] = useState([]);
  const [employee_master, setEmployee_master] = useState([]);
  const [productId, setProductId] = useState();
  const [employeeId, setEmployeeId] = useState();
  const [editData, setEditData] = useState({});
  const userdata = JSON.parse(sessionStorage.getItem('userdata'));
  const branchId = userdata.branch_id;
  

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showEdit, setShowEdit] = useState(false);

  // =========== delete modal =========
 const [show1, setShow1] = useState(false);
 const handleClose1 = () => setShow1(false);

 const [itemToDelete, setItemToDelete] = useState(null);

 const handleShow1 = (item) => {
   setItemToDelete(item);
   setShow1(true);
 };  


//  =========== Edit ======
  const handleEditClose = () => {
    setShowEdit(false);
    // setStockId('');
    setQuantity('');
    setProductId('');
    setDate('');
    setEmployeeId('');
    setId('');
  };

  const setEditDataFun = (item) => {
    console.log("Setting isEditing to true");
    setProductId(item.product_id);
    setEmployeeId(item.employee_id);
    // setStockId(item.stock_id);
    setId(item.id);
    setQuantity(item.quantity);
    setDate(item.date);
    setisEditing(true);
  }

  const updateDailyStock = () => {

    if ( !productId  || !quantity) {
      alert("Please fill in all fields");
      return;
  }
    const formData = {
      product_id :productId,
      quantity :quantity,
      employee_id : employeeId,
    };
    console.log("update api con...",formData);
    axios
      .put(`${DailyStockUpdate}${id}`, formData)
      .then((res) => {
        console.log("update ....",res);
        if (res.data === "UPDATE") {
          
          toast.success("Data Updated Successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          Getdata1();
          handleEditClose();
        }
        else if(res.data === "ALREADYEXIST")
        toast.info("Data Already Exists ..!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      })
      .catch((err) => {
        // Add debugging information to identify the issue
        console.error("Error while updating Employee:", err);
        if (err.response) {
          console.error("Response data:", err.response.data);
        }
  
        toast.error("Failed to update data, please try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };


const savedata = (e) => {
    e.preventDefault();
  
    if ( !productId  || !employeeId || !date || !quantity) {
      alert("Please fill in all fields");
      return;
  }
  const formattedDate = dayjs(date).format('DD/MM/YYYY');
    const obj ={
      employee_id : employeeId,
      product_id :productId,
      quantity :quantity,
      date :formattedDate,
      branch_id: branchId

    }
    console.log("FormData",obj)
  
    axios
      .post(DailyStockAdd, obj)
      .then((res) => {
        
        if (res.data === "SAVED") {
          console.log("res.data",res.data)
          toast.success("Data Saved Successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          // Reset form fields and reload the data
          Getdata();
          setProductId('');
          setEmployeeId('');
          // setStockId('');
          setDate('');
          setId('');
          setQuantity('');
          setShow(false);
          // window.location.reload(); // Note: Reloading the entire page may not be the best practice, consider updating the data from the API.
        }
        else if(res.data === "ALREADYEXIST")
        toast.info("Data Already Exists ..!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      })
      .catch((err) => {
        toast.error("Failed to upload, please try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.error(err);
      });
  };

     //Getdata Logic
     const Getdata = (e) => {

      if (!date) {
        // date is not set, handle accordingly
        return;
      }
      console.log("date console...",date);
      const formattedDate = dayjs(date).format('DD/MM/YYYY');

      const Obj ={
        date :formattedDate,
        employee_id : employeeId,
        branch_id : branchId
      }
      console.log("Obj",Obj)
      axios  
        .post(DailyStockFindAll ,Obj)
        .then((res) => {
          console.log("findallllllllll",res.data)
          if (res.data !== null) {
            setData(res.data);
          }
          setisEditing(false);
        })
        .catch((err) => {
          // alert("Failed to upload, try again");
          toast.error("Failed to upload, try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          console.log(err);
        });
    };

    const Getdata1 = (e) => {

      if (!date) {
        // date is not set, handle accordingly
        return;
      }

      const Obj ={
        date :date,
        employee_id : employeeId,
        branch_id : branchId
      }
      console.log("Obj",Obj)
      axios  
        .post(DailyStockFindAll ,Obj)
        .then((res) => {
          console.log("findallllllllll",res.data)
          if (res.data !== null) {
            setData(res.data);
          }
          setisEditing(false);
        })
        .catch((err) => {
          // alert("Failed to upload, try again");
          toast.error("Failed to upload, try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          console.log(err);
        });
    };
  
  // useEffect(() => {
  //   Getdata();
  // }, [date,employeeId])
  
  
    //delete data
    const onDelete = (item) => {
      console.log("Deleting item:", item);
      axios
        .delete(`${DailyStockDelete}${item.id}`)
        .then((res) => {
          console.log("Delete response:", res.data);
          if (res.data === "DELETE") {
            toast.success("Data Deleted Successfully!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
    
            // Update the data state to remove the deleted item
            setData((currentData) => {
              return currentData.filter((dataItem) => dataItem.id !== item.id);
            });
          }
          handleClose1(false);
          // No need to call Getdata() if you're updating the state directly
        })
        .catch((err) => {
          console.log("Error deleting item:", err);
          toast.error("Failed to delete, please try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        });
    };
    
     //EmployeeData Logic
 const Employeedata = (e) => {
  axios  
    .get(`${EmployeeFindAll}/${branchId}`)
    .then((res) => {
      if (res.data !== null) {
        setEmployee_master(res.data);
      }
      setisEditing(false);
    })
    .catch((err) => {
      // alert("Failed to upload, try again");
      toast.error("Failed to upload, try again", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      console.log(err);
    });
};


   //ProductData Logic
 const Productdata = (e) => {
  axios  
    .get(`${ProductFindAllOrderAllotment}/${branchId}`)
    .then((res) => {
      if (res.data !== null) {
        setProduct_master(res.data);
      }
      setisEditing(false);
    })
    .catch((err) => {
      // alert("Failed to upload, try again");
      toast.error("Failed to upload, try again", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      console.log(err);
    });
};


useEffect(() => {
  if (isEditing === false) {
    Getdata();
    Getdata1();
    Productdata();
    Employeedata();

  }
}, [isEditing]);

 //HEADING FONT ===================

 const headingStyle = {
  fontSize: '27px',
  fontWeight: 'bold',
  textAlign: 'center',
};

const subheadingStyle = {
  color: 'rgb(255, 93, 0)', // Assuming this is the color for "text-violet-800"
  fontWeight: 300, // Assuming this is the font weight for "font-[300]"
  textShadow:"3px 1px 5px rgb(180, 180, 180)",
};
  
  return (
    <Container fluid>
        <Row> <AdminHeader /> </Row>

        <Row  className='BgImg px-md-5'>

   {/* ====================== table =============== */}
     <Row className='m-0 p-0  px-md-5  py-1 mb-5  w-100' style={{display:"flex"}}>

   <Row className='pt-3'>
   <div className="heading text-black pt-3 pt-2 pt-md-2 mt-2 mt-md-1 mb-3" style={headingStyle}>
           <span style={subheadingStyle}>Daily</span> Stock
           </div>
   </Row>
   <Row style={{display:"flex",justifyContent:"space-evenly"}}>
   <Col sm={12} md={3} className='mt-2'>
  {/* {isEditing ? (
    <TextField
      size="small"
      type="date"
      style={{ width: '100%' }}
      value={date || ''}
      readOnly
    />
  ) : (
    <TextField
      size="small"
      style={{ width: '100%' }}
      type="date"
      value={date || ''}
      onChange={(e) => setDate(e.target.value)}
    />
  )} */}

 
  {isEditing ? (null  ) : (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={['DatePicker']}>
    <DatePicker
      format="DD-MM-YYYY"
      label="Select Date"
      value={date}
      onChange={(newDate) => {
        console.log("date res", newDate);
        setDate(newDate);
      }}
      slotProps={{ textField: { size: 'small' } }}
    />
  </DemoContainer>
</LocalizationProvider>
  )}

          
</Col>

    <Col sm={12} md={3} className='mt-3'>
  {isEditing ? (
    <TextField
      size="small"
      style={{ width: '100%' }}
      label="Select Employee"
      value={employee_master.find((item) => item.employee_id === employeeId)?.name || ''}
      readOnly
    />
  ) : (
    <Autocomplete
      disablePortal
      size="small"
      style={{ width: '100%' }}
      id="combo-box-demo"
      options={employee_master}
      getOptionLabel={(option) => option.name}
      value={employee_master.find((item) => item.employee_id === employeeId) || null}
      onChange={(e, newValue) => setEmployeeId(newValue ? newValue.employee_id : '')}
      renderInput={(params) => <TextField {...params} label="Select Employee" />}
    />
  )}
</Col>

   <Col sm={12} md={3} className='mt-3'>
       <Autocomplete
          disablePortal
          style={{ width: '100%' }}
          id="combo-box-demo"
          options={product_master}
          size="small"
          getOptionLabel={(option) => option.product_name} 
          value={product_master.find((item) => item.product_id === productId) || null}
          onChange={(e, newValue) => setProductId(newValue ? newValue.product_id : '')}
          renderInput={(params) => <TextField {...params} label="Select Product" />}
        />
      </Col>

      <Col sm={12} md={3} className='mt-3'>
          <TextField
          size="small"
          id="outlined-basic"
          style={{ width: '100%' }}
          label="Enter Quantity"
          placeholder='Enter Quantity'
          type="number"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
        />
      </Col>
   </Row>

   <Row  className='mt-4 mb-3'>
   <Col style={{ display: "flex", justifyContent: "center" }}>
      {isEditing === false ? (
        <Button
          style={{
            border: "2px solid rgb(47, 79, 79)",
            backgroundColor:
              "rgb(47, 79, 79)",
              fontSize:"17px",
              color:"white",
            borderRadius: "15px",
          }}
          className="py-2 px-3 mx-2 shadow "
          type="submit"
          onClick={savedata}
        >
          Save
        </Button>
      ) : (
        <div>
        <Button
          style={{
            border: "2px solid rgb(47, 79, 79)",
            backgroundColor: "rgb(47, 79, 79)",
            borderRadius: "15px",
          }}
          className="py-2 px-3 mx-2 shadow text-light"  
          onClick={updateDailyStock}
        >
          Update
        </Button>
        </div>
        
      )}
    </Col>
      </Row>

   <div style={{ overflowY: 'auto'}}>
  <div style={{ overflowX: 'auto' }}>
     <Table striped bordered hover size="sm" className='shadow mb-5 mt-2' style={{textAlign:"center"}}>
         <thead >
             <tr > 
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Sr.No</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Date</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Employee</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Product</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Quantity</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Edit</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Delete</th>
             </tr>
         </thead>
         <tbody>
           {data.map((item,index)=>{
             return(               
             <tr className='border' >
                 <td style={{ textAlign:"center"}}>{index+1}</td>
                 <td style={{ textAlign:"center"}}>{item.date}</td>
                 <td style={{ textAlign:"center"}}>{item.name}</td>
                 <td style={{ textAlign:"center"}}>{item.product_name}</td>
                 <td style={{ textAlign:"center"}}>{item.quantity}</td>
                 <td style={{textAlign:"center"}}>
                <button className=' m-1' style={{color:"rgb(255, 93, 0)",border:"0px", backgroundColor:"transparent"}}
                  onClick={() => setEditDataFun(item)}
                ><i class="fa-solid fa-pen-to-square"></i></button></td>

                <td style={{textAlign:"center"}}>
                <button className=' m-1' style={{color:"red",border:"0px", backgroundColor:"transparent"}}
                
                onClick={() => handleShow1(item)}
                 ><i className="fa-solid fa-trash"></i></button></td>
             </tr>
              )
             })} 
         </tbody>
     </Table>
     </div>
     </div>
   </Row>

 

 {/* ============= Delete Modal ========= */}

  <Modal show={show1} onHide={handleClose1}>
      <Modal.Header style={{backgroundColor:"rgb(214, 234, 248)",color:"black"}} >
        <Modal.Title><i className="fa-solid fa-trash" style={{ color: "rgb(254, 105, 129)" }}></i>  Delete Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body >Are you sure you want to delete this item?</Modal.Body>
        <p className='text-end'>
        <Button className='mx-2' style={{color:"black",backgroundColor:"white",border:"2px solid darkslategray",borderRadius:"15px"}}  onClick={handleClose1}>
          Cancel
        </Button>
        <Button  style={{border:"1px solid darkslategray",backgroundColor:"darkslategray" ,borderRadius:"15px"}} className='py-2 px-3 mx-2  shadow text-light' onClick={() => onDelete(itemToDelete)}>
          Delete
        </Button></p>
    </Modal>

</Row>

    </Container>
  )
}

export default DailyStock
